import axios from 'axios';
import { ElNotification } from 'element-plus';

const logAxios = axios.create({
    baseURL: process.env.NODE_ENV === "production" ? "https://api.theauditer.com/api" : "https://test.theauditer.com/api",
})

logAxios.interceptors.response.use(response => {

    if (!response.data.Success) {
        setTimeout(() => {
            ElNotification({
                title: "",
                message: response.data.Message,
                type: 'warning',
                position: 'top-right',
                zIndex: 20000,
                duration: 3200,
                customClass: "notification-app-vue"
            })
        }, 500)
    }
    return response

}, error => {
    console.log(error.response.status)
})


export default logAxios